import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { compose } from 'redux';
import striptags from 'striptags';

import { formatNewLines, stripNbsp } from '~/utils/text';

/** Truncate text and replace with …*/
const clamp = maxLength => str =>
  str.length <= maxLength ? str : `${str.slice(0, maxLength).trim()}\u2026`;

const PlainText = ({
  children,
  maxLength = Number.MAX_VALUE,
  renderAs: AsComponent = Fragment,
}) => {
  if (children == null) {
    return null;
  }

  const sanitizedChildren = compose(
    formatNewLines,
    clamp(maxLength),
    stripNbsp,
    striptags,
  )(children);

  return <AsComponent>{sanitizedChildren}</AsComponent>;
};

PlainText.propTypes = {
  children: PropTypes.string,
  maxLength: PropTypes.number,
  renderAs: PropTypes.elementType,
};

export default PlainText;
